import React from 'react'
import { Box, Skeleton } from '@mui/material'

export const ListSkeleton = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Box sx={styles.container} key={index}>
          <Box className='row' sx={styles.row}>
            <Box sx={styles.topic}>
              <Skeleton variant='text' width='80%' height={24} />
            </Box>
            <Box sx={styles.actions}>
              <Skeleton variant='text' width='70%' height={24} />
              <Skeleton variant='text' width='50px' height={24} />
            </Box>
          </Box>
        </Box>
      ))}
    </>
  )
}

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    height: '72px',
    borderBottom: '1px solid #E7E7EE',
    alignItems: 'center'
  },
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  topic: {
    width: '80%'
  },
  actions: {
    width: '18%',
    display: 'flex',
    justifyContent: 'center',
    columnGap: '8px'
  }
}
